import { lazy } from 'react';
import { RouteObject } from 'react-router';
import Loadable from 'components/Loadable';
import PublicGuard from 'utils/route-guard/PublicGuard';
import CommonLayout from 'layout/CommonLayout';

const OrganizationDetails = Loadable(lazy(() => import('pages/public/OrganizationDetails')));
const OrganogramPublic = Loadable(lazy(() => import('pages/public/OrganogramPublic')));
const SignatureValidation = Loadable(lazy(() => import('pages/public/SignatureValidation')));
const Dashboard = Loadable(lazy(() => import('pages/public/dashboard')));
const CapsuleDetails = Loadable(lazy(() => import('pages/public/CapsuleDetails')));
const OriginalDocumentDownload = Loadable(lazy(() => import('pages/public/OriginalDocumentDownload')));

const DashboardRoutes: RouteObject = {
  path: '/organization/:organizationId',
  element: (
    <PublicGuard>
      <CommonLayout layout={'landing'} />
    </PublicGuard>
  ),
  children: [
    {
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      path: 'organogram',
      element: <OrganogramPublic />
    },
    {
      path: 'details',
      element: <OrganizationDetails />
    },
    {
      path: 'signature-validation',
      element: <SignatureValidation />
    },
    {
      path: 'capsule/:capsuleId',
      element: <CapsuleDetails />
    },
    {
      path: 'original-document-download',
      element: <OriginalDocumentDownload />
    },
    {
      path: '',
      element: <Dashboard />
    }
  ]
};

export { DashboardRoutes };
